import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Siren, ArrowRight } from 'lucide-react';
import useGameStore from '../../store/gameStore';
import MarkdownLite from '../MarkdownLite';
import { getPendingUrgentMessages } from '../../utils/messagePriority';

/**
 * Dashboard — messages URGENTS non lus affichés directement (pas seulement
 * en popup) : le lendemain, l'apprenant voit le contenu sans ouvrir la
 * Messagerie. Retour apprenant : « pour les urgences, afficher directement
 * le message le jour suivant ».
 */
export default function UrgentMessagesBanner() {
  const inbox = useGameStore((s) => s.inbox);
  const totalDays = useGameStore((s) => s.totalDays) || 0;
  const markMessageRead = useGameStore((s) => s.markMessageRead);
  const navigate = useNavigate();
  const urgent = getPendingUrgentMessages(inbox, totalDays, 3);
  if (urgent.length === 0) return null;
  return (
    <div className="rounded-lg border border-rose-500/50 bg-rose-500/10 p-3 space-y-2" data-testid="urgent-messages-banner">
      <div className="flex items-center gap-2 text-rose-200">
        <Siren className="w-4 h-4 animate-pulse" />
        <p className="text-xs font-bold uppercase tracking-wider">
          {urgent.length} message{urgent.length > 1 ? 's' : ''} urgent{urgent.length > 1 ? 's' : ''} en attente
        </p>
      </div>
      <ul className="space-y-2">
        {urgent.map((m) => (
          <li key={m.id} className="bg-ink-900/60 border border-rose-500/30 rounded-md px-3 py-2" data-testid={`urgent-message-${m.id}`}>
            <div className="flex items-start justify-between gap-2 flex-wrap">
              <div className="min-w-0">
                <p className="text-[10px] text-slate-400">{m.senderName} · reçu J{m.receivedDay}{m.kind === 'decision' && !m.replied ? ` · expire J${m.expiresDay}` : ''}</p>
                <p className="text-sm font-semibold text-slate-100">{m.subject}</p>
              </div>
              <button
                type="button"
                onClick={() => navigate(`/messagerie?open=${encodeURIComponent(m.id)}`)}
                className="inline-flex items-center gap-1 text-[11px] font-bold text-rose-200 border border-rose-400/50 rounded px-2 py-1 hover:bg-rose-500/20 flex-shrink-0"
                data-testid={`urgent-open-${m.id}`}
              >
                {m.kind === 'decision' && !m.replied ? 'Décider' : 'Ouvrir'} <ArrowRight className="w-3 h-3" />
              </button>
            </div>
            <div className="text-xs text-slate-300 mt-1.5 leading-relaxed whitespace-pre-wrap max-h-24 overflow-hidden" data-testid={`urgent-body-${m.id}`}>
              <MarkdownLite text={String(m.body || '').slice(0, 320) + (String(m.body || '').length > 320 ? '…' : '')} as="div" strongClassName="text-foreground font-semibold" />
            </div>
            {m.kind !== 'decision' && (
              <button type="button" onClick={() => markMessageRead(m.id)} className="text-[10px] text-slate-500 hover:text-slate-300 mt-1" data-testid={`urgent-dismiss-${m.id}`}>
                Marquer comme lu
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
